<div class="main-container">
    <div class="model-header">
        <div class="modal-title">Conflicts({{conflictArr.length}})</div>
        <img (click)="onClose()" class="h-icon cursor-pointer close-icon" src="assets/images/icons/close_icon.svg" alt="">
    </div>
    <div class="content-block flex-grow-1">
        <!-- <div class="tab-box mb-2 align-items-center">
            <div class="d-flex justify-content-center align-items-center tab-item me-2 mb-2" id="i-4"
                (click)="onTabChange('upComing')" [ngClass]="currentTab == 'upComing' ? 'active-tab' : ''"
                matTooltip="Requests for the Open shifts">
                <div class="tab-txt ps-1 ps-sm-2">Upcoming</div>
            </div>
            <div class="d-flex justify-content-center align-items-center tab-item me-2 mb-2" id="i-1"
                matTooltip="Request for the Swap shifts" [ngClass]="currentTab == 'history' ? 'active-tab' : ''"
                (click)="onTabChange('history')">
                <div class="tab-txt ps-1 ps-sm-2">History</div>
            </div>
        </div> -->

        <div class="tab-content flex-grow-1 d-flex flex-column mt-3">

            <div class="d-flex flex-column gap-3 overflow-auto">

                <div class="d-flex flex-column gap-3" *ngIf="conflictArr.length > 0">
                    <div class="content-c d-flex flex-column gap-3">
                        <div class="w-100 m-title mt-2">Overlapping shifts</div>
                        <div class="d-card d-flex gap-3" *ngFor=" let item of conflictArr">
                            <div class="profile-p">
                                <img *ngIf="!item.profile_icture" src="assets/images/icons/employee.png" alt="">
                                <img *ngIf="item.profile_icture" src="assets/images/icons/employee.png" alt="">
                            </div>
                            <div class="user-d">
                                <div class="user-n">{{item.first_name}} {{item.last_name}}</div>
                                <div class="note">{{item.total_records}} overlapping shifts on  {{item.date}}</div>
                            </div>
                            <button type="button" (click)="onClose()" class="btn btn-outline-primary ms-auto">View</button>
                        </div>
                    </div>
                </div>

                <div class="content-c" *ngIf="conflictArr.length == 0">
                    <div class="thmub-ic mb-3">
                        <img src="assets/images/icons/thumb_ic.png" class="img-fluid" alt="">
                    </div>
                    <div class="m-title "> No conflicts to display </div>
                    <div class="m-sub-title"> Everything seems to be running smoothly </div>
                    <!-- <button mat-raised-button color="primary" class="auth-form-btn mt-3 mb-3">Set scheduler
                        limitations</button> -->
                </div>

            </div>

        </div>
    </div>
</div>